import dynamic from 'next/dynamic';
import { ComponentType } from 'react';
import type { IconFacebookCoverImageType } from '@swc-react/icons-workflow/FacebookCoverImage';
export const SpIconFacebookCoverImage: ComponentType<Partial<IconFacebookCoverImageType> | { slot: string }> = dynamic(
  () => import('@swc-react/icons-workflow/FacebookCoverImage').then((m) => m.IconFacebookCoverImage as any),
  { ssr: false}
);
